var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasteCat5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.023,
    height: 35.197,
    viewBox: "0 0 23.023 35.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "waste",
    d: "M117.073,24.885c1.9,0,3.505,1.687,3.993,3.987H116.24a6.7,6.7,0,0,0-2.26-2.162A3.8,3.8,0,0,1,117.073,24.885Zm-16.9,1.256c-.84.485-1.435,1.442-1.044,2.12l1.18,2.045a.247.247,0,0,0,.354.09l19.886-11.481a.247.247,0,0,0,.1-.351l-1.18-2.045c-.395-.684-1.517-.641-2.358-.156l-5.151,2.974c-.2-.373-.452-.932-.683-1.262a1.258,1.258,0,0,0-1.653-.42l-4.557,2.63a1.263,1.263,0,0,0-.461,1.724l.681,1.18ZM106.3,22.6l-.682-1.182a.1.1,0,0,1,.034-.124l4.525-2.612a.089.089,0,0,1,.113.019l.654,1.217Zm-2.685,7.442h18.413l-1.794,19.534a1.8,1.8,0,0,1-1.809,1.618H105.056a1.8,1.8,0,0,1-1.809-1.618l-1.685-18.35Zm14.456,4.208h-2.035l-1,10.9h2.035Zm-5.3,0H110.74l-.028,10.9h2.026Zm-7.72,0,1,10.9h2.035l-1-10.9Zm6.359-7.061a4.474,4.474,0,0,0-3.378,1.68h6.756A4.474,4.474,0,0,0,111.406,27.192Z",
    transform: "translate(-99.002 -16)",
    fill: "#86899b",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteCat5);
export default __webpack_public_path__ + "static/media/waste_cat_5.c0b80afb4eed00feb0223dbf9b6e264f.svg";
export { ForwardRef as ReactComponent };